import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export interface ContactInfo {
  phone: string;
  email: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
  };
  businessHours: {
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
  };
}

class ContactService {
  private readonly DOCUMENT_ID = 'contact_info';
  private readonly COLLECTION = 'settings';
  
  // Get the contact information
  async getContactInfo(): Promise<ContactInfo> {
    try {
      const docRef = doc(db, this.COLLECTION, this.DOCUMENT_ID);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        // Return default values if no contact info exists yet
        return this.getDefaultContactInfo();
      }
      
      return docSnap.data() as ContactInfo;
    } catch (error) {
      console.error('Error fetching contact info:', error);
      return this.getDefaultContactInfo();
    }
  }
  
  // Update the contact information
  async updateContactInfo(contactInfo: ContactInfo): Promise<void> {
    try {
      const docRef = doc(db, this.COLLECTION, this.DOCUMENT_ID);
      await setDoc(docRef, contactInfo);
    } catch (error) {
      console.error('Error updating contact info:', error);
      throw error;
    }
  }
  
  // Default contact information
  private getDefaultContactInfo(): ContactInfo {
    return {
      phone: '(555) 123-4567',
      email: 'info@ridgelinehomes.com',
      address: {
        street: '123 Builder Street',
        city: 'City',
        state: 'State',
        zipCode: '12345'
      },
      businessHours: {
        monday: '9AM - 5PM',
        tuesday: '9AM - 5PM',
        wednesday: '9AM - 5PM',
        thursday: '9AM - 5PM',
        friday: '9AM - 5PM',
        saturday: '10AM - 2PM',
        sunday: 'Closed'
      }
    };
  }
}

export const contactService = new ContactService(); 